export enum PricePlans {
  Free = 'Free',
  VerificationPlus = 'Verification Plus',
  Pro = 'Pro',
}
